import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ConfluenceBlueprint } from '../types.tsx';

export const getBlueprint = async (
	cloudId: string,
	spaceKey: string,
	blueprintModuleCompleteKey: string,
): Promise<ConfluenceBlueprint> => {
	let blueprints;
	const url = `/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/blueprints/web-items?spaceKey=${spaceKey}`;
	try {
		blueprints = await fetchJson<ConfluenceBlueprint[]>(url);
		const found = blueprints.find(
			(blueprint) => blueprint.blueprintModuleCompleteKey === blueprintModuleCompleteKey,
		);
		if (!found) {
			throw new Error(
				`Fetching blueprints succeeded, but blueprint: ${blueprintModuleCompleteKey} was not found for space: ${spaceKey}`,
			);
		}
		return found;
	} catch (error: unknown) {
		fireErrorAnalytics({
			meta: {
				id: 'createConfluenceDraftGetBlueprint',
				packageName: 'jiraIssueViewBase',

				teamName: 'starburst',
			},
			error: {
				name: 'error',
				message: `Unknown error calling getBlueprint for space: ${spaceKey}`,
			},
		});
		throw error || new Error(`Error calling ${url}`);
	}
};
